exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".autocomplete-results[data-v-a72cac12]{position:absolute;z-index:1000;width:250px;left:24px;background-clip:border-box;background:#fff;border:1px solid rgba(14,14,14,.125);border-radius:.25rem;box-shadow:0 4px 10px rgba(0,0,0,.15)}.autocomplete-results ul[data-v-a72cac12]{list-style:none;margin-bottom:0;padding-left:0}.autocomplete-results ul li[data-v-a72cac12]{overflow:hidden;cursor:pointer;padding:16px}.autocomplete-results ul li[data-v-a72cac12]:hover{background-color:#eee}", ""]);

// exports
